<h1 *ngIf="role != 'doctor'">Hello {{name}}!</h1>
<h1 *ngIf="role == 'doctor'">Hello Dr. {{name}}!</h1>

<div class="patient" *ngIf="role != 'doctor'">
    <h1>Your Records</h1>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <!-- Position Column -->
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef> No. </th>
          <td mat-cell *matCellDef="let element"> {{element.position}} </td>
        </ng-container>
      
        <!-- Name Column -->
        <ng-container matColumnDef="path">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.path}} </td>
        </ng-container>
      
        <!-- Download Column -->
        <ng-container matColumnDef="downloadURL">
          <th mat-header-cell *matHeaderCellDef> Download </th>
          <td mat-cell *matCellDef="let element"> {{element.downloadURL}} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
            
    <h1>Upload Record</h1>
    <uploader></uploader>
</div>

<div class="doctor" *ngIf="role == 'doctor'">
    <h1>Search for Patient</h1>
      
      <table mat-table [dataSource]="patientDataSource" class="mat-elevation-z8">
        <!-- Position Column -->
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef> No. </th>
          <td mat-cell *matCellDef="let element"> {{element.position}} </td>
        </ng-container>
      
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
      
        <!-- Download Column -->
        <ng-container matColumnDef="records">
          <th mat-header-cell *matHeaderCellDef> Records </th>
          <td mat-cell *matCellDef="let element"> {{element.records}} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="patientDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: patientDisplayedColumns;"></tr>
      </table>
      
</div>
